import React from "react";
import { useIntl } from "react-intl";

import {
    Form,
    TextArea
} from "@gpstrackit/gtc-react-controls";

const Notes = ({
    formData,
    setFormData,
}) => {
    const { messages } = useIntl();

    return (
        <Form.Item
            name="notes"
            label={messages["fleetModalUpdateUnit_notes"]}
        >
            <TextArea
                id="notes"
                placeholder={messages["fleetModalUpdateUnit_notes"]}
                onChange={(value) => {
                    setFormData({
                        ...formData,
                        notes: value
                    });
                }}
            />
        </Form.Item>
    );
}

export default Notes;